import React, { type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMessagesForRange } from 'atom-components/error-message-from-hook-form';
import NumberRange, {
  AppliedNumberRange
} from 'atom-components/form-fields-for-hook-form/number-range';
import Label from 'atom-components/label';
import TooltipItem from 'atom-components/tooltip-item';
import { commonNumberInputMax, commonNumberInputMin } from 'schemas/number.schema';
import { filterFormDefaultValues } from './filter-form.schema';

const rangeFieldLabel = 'Number of Marks';
const rangeFieldName = 'numberOfMarks';
const fromFieldName = `${rangeFieldName}From`;
const toFieldName = `${rangeFieldName}To`;

type Props = {
  triggerFormSubmission: () => void;
};

export default function NumberOfMarksFilter({ triggerFormSubmission }: Props): ReactElement {
  const { watch, formState } = useFormContext();
  const numberOfMarksFrom = watch(fromFieldName);
  const numberOfMarksTo = watch(toFieldName);

  return (
    <div>
      <TooltipItem
        tooltip={`Displays responses that have between ${numberOfMarksFrom !== '' ? numberOfMarksFrom : 'X'} and ${numberOfMarksTo !== '' ? numberOfMarksTo : 'X'} marks started.`}
      >
        <Label htmlFor={fromFieldName}>{rangeFieldLabel}</Label>
      </TooltipItem>
      <NumberRange
        id={rangeFieldName}
        fromName={fromFieldName}
        toName={toFieldName}
        ariaLabel={rangeFieldLabel}
        min={commonNumberInputMin}
        max={commonNumberInputMax}
        onChange={(): void => triggerFormSubmission()}
        debounceOnChange
      />
      <ErrorMessagesForRange
        errors={formState.errors}
        fromName={fromFieldName}
        toName={toFieldName}
      />
    </div>
  );
}

export function NumberOfMarksAppliedFilter({ triggerFormSubmission }: Props): ReactElement | null {
  return (
    <AppliedNumberRange
      rangeLabel={rangeFieldLabel}
      fromName={fromFieldName}
      toName={toFieldName}
      defaultFromValue={filterFormDefaultValues.numberOfMarksFrom}
      defaultToValue={filterFormDefaultValues.numberOfMarksTo}
      onClear={(): void => triggerFormSubmission()}
    />
  );
}
